import { Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { environment } from '../../../../environments/environment';
import { apiErrorCode } from '../../errors/api-error';

@Injectable({
  providedIn: 'root',
})
export class ErrorReportingService {
  report(error: unknown, context: string): void {
    console.error(context, error);
    // A coded API response is already captured by the backend; reporting it again from here would
    // only duplicate it. Only a failure the API never answered — a network error, a body-less
    // response, a non-HTTP throw — is the frontend's to report.
    if (environment.production && apiErrorCode(error) === undefined) {
      Sentry.captureException(error, { tags: { context } });
    }
  }
}
